import React from 'react';
import '../styles/contact.css'; // Reuse same CSS

function ContactForm() {
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const data = {
            name: formData.get("name"),
            email: formData.get("email"),
            message: formData.get("message"),
        };

        try {
            const response = await fetch("http://localhost:5001/api/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            alert(result.message);
        } catch (error) {
            console.error("Error submitting contact form:", error);
            alert("Something went wrong. Try again later.");
        }
    };

    return (
        <form className="contact-form" onSubmit={handleSubmit}>
            <input type="text" placeholder="Full Name" name="name" required />
            <input type="email" placeholder="Email Address" name="email" required />
            <textarea placeholder="Your Message" name="message" rows="6" required></textarea>
            <button type="submit" className="btn-primary">Send Message</button>
        </form>
    );
}

export default ContactForm;